import '../styles/SimpleLoader.css'

const SimpleLoader = () => {
    return (
        <div className="loader-container">
            <div className="loader"></div>
        </div>
    )
}

export default SimpleLoader